import { Button, Modal } from 'antd';

import { logout } from '../../utils/authUtils';

const LogoutModal = ({ isOpen, onClose }) => {
  function handleLogout() {
    onClose();
    logout();
  }

  return (
    <Modal open={isOpen} width={290} footer={null} onCancel={onClose} closeIcon={null} centered>
      <h4 className='mb-16'>Are you sure you want to Log Out?</h4>
      <div className='flex' style={{ gap: '12px', justifyContent: 'end' }}>
        <Button type='default' className='btn-s' onClick={onClose}>
          Cancel
        </Button>
        <Button type='primary' className='btn-s' danger onClick={handleLogout}>
          Log Out
        </Button>
      </div>
    </Modal>
  );
};

export default LogoutModal;
